import { Component } from '@angular/core';
import { BlockH1Component } from '@gallaghercp/core-frontend';

@Component({
    selector: 'core-block-h2-anchor',
    template: `
        <ng-container>
            <div class="heading__wrapper">
                @if (block.data.heading) {
                    <h2 class="heading__main" [innerHTML]="block.data.heading"></h2>
                }
                <h2
                    class="heading__anchor"
                    [class]="block.data.heading ? '' : 'heading__anchor--no-heading'"
                    [attr.id]="slugify(block.data.text)"
                    [innerHTML]="' / ' + block.data.text"
                ></h2>
            </div>
        </ng-container>
    `,
    standalone: false,
})
export class BlockH2AnchorComponent extends BlockH1Component {
    slugify(text: string) {
        return text.toLowerCase().replace(/[^a-zA-Z0-9]+/g, '-');
    }
}
